import { render } from "./AccessDenied.vue?vue&type=template&id=6d2883ae&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=6d2883ae&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2883ae"]])

export default __exports__